module.exports = __webpack_public_path__ + "static/Health-checkup1-7f54000f95465c97bd51200749049c1c.jpg";